"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderRenameFunction = void 0;
const helpers_1 = require("./helpers");
const getHeaderRenameFunction = (sanitizeFieldNames) => {
    return (rawHeader) => (0, helpers_1.getSanitizedFieldName)(rawHeader, sanitizeFieldNames);
};
exports.getHeaderRenameFunction = getHeaderRenameFunction;
//# sourceMappingURL=stream.js.map